export default "__VITE_ASSET__ce799801__"